export const logo = 'rummyLogo.png'
